<template>
  <OrderPackingDetail label="Pengeluaran Grup" pengemasan-path="gudang.reimbursement-group.pengemasan" :cancelable="false" :index-path="{ name: 'gudang.reimbursement-group.index' }" />
</template>

<script>
import OrderPackingDetail from '../../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail },
  created() {
  }
}
</script>